<div
  class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
>
  <h4
    class="gw-text-xl gw-font-semibold gw-text-text-primary"
    id="modal-basic-title"
  >
    {{ 'features.integrations.configureCredentials' | translate }}
  </h4>
</div>
<div class="gw-p-6">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="gw-space-y-4">
    <div class="gw-mb-4">
      <label
        for="apiKey"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.apiKey' | translate }}
      </label>
      <input
        id="apiKey"
        type="text"
        class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
        formControlName="apiKey"
        [placeholder]="'features.integrations.apiKeyPlaceholder' | translate"
      />
      <small class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block">
        {{ 'features.integrations.apiKeyWarning' | translate }}
      </small>
      <small
        *ngIf="form.get('apiKey')?.invalid && form.get('apiKey')?.touched"
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.apiKeyRequired' | translate }}
      </small>
    </div>
    <div class="gw-mb-4">
      <label
        for="barteApiKey"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.barteApiKey' | translate }}
      </label>
      <input
        id="barteApiKey"
        type="text"
        class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
        formControlName="barteApiKey"
        [placeholder]="'features.integrations.apiKeyPlaceholder' | translate"
      />
      <small class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block">
        {{ 'features.integrations.apiKeyWarning' | translate }}
      </small>
      <small
        *ngIf="
          form.get('barteApiKey')?.invalid && form.get('barteApiKey')?.touched
        "
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.apiKeyRequired' | translate }}
      </small>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        [title]="'common.actions.cancel' | translate"
        variant="secondary"
        (click)="close()"
      ></gatewee-button>
      <gatewee-button
        [title]="
          submitting
            ? ('common.actions.saving' | translate)
            : ('common.actions.save' | translate)
        "
        variant="primary"
        type="submit"
        [disabled]="form.invalid || submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
